// frontend/src/components/conversion/conversionPopupBlockers.js
//
// "Is this a bad MOMENT to show the popup?" - checked when the trigger fires,
// never before. A blocked moment DEFERS the popup (the gate re-checks shortly),
// it never cancels it.
//
// Detected generically from the DOM, so a dialog added to the site tomorrow is
// covered without a line here: the homepage WaitlistModal and
// EnterpriseContactModal, any MUI Dialog/Drawer/Menu (all MUI Modals), any
// hand-rolled `aria-modal` dialog. The popup's own root is never counted - it
// is marked `data-lf-section="popup"`.

/** The popup's own root marker (also read by the page-engagement tracker). */
export const POPUP_ROOT_SELECTOR = '[data-lf-section="popup"]';

// An open modal of any kind. `.MuiModal-hidden` is a closed, keepMounted one.
const OPEN_MODAL_SELECTOR = [
  '[role="dialog"][aria-modal="true"]',
  '[role="alertdialog"]',
  ".MuiModal-root:not(.MuiModal-hidden)",
].join(", ");

// <input> types that take no typing - focus on one is not "typing".
const NON_TEXT_INPUT_TYPES = new Set([
  "button",
  "checkbox",
  "color",
  "file",
  "hidden",
  "image",
  "radio",
  "range",
  "reset",
  "submit",
]);

/**
 * Is another modal dialog open on the page?
 *
 * @returns {boolean}
 */
export function isOtherDialogOpen() {
  try {
    const open = document.querySelectorAll(OPEN_MODAL_SELECTOR);
    for (let i = 0; i < open.length; i += 1) {
      if (!open[i].closest(POPUP_ROOT_SELECTOR)) return true;
    }
    return false;
  } catch {
    // An unreadable DOM is not proof of a free screen.
    return true;
  }
}

/**
 * Is the visitor typing in a field outside the popup right now?
 *
 * @returns {boolean}
 */
export function isTypingElsewhere() {
  try {
    const el = document.activeElement;
    if (!el || el === document.body || el.closest(POPUP_ROOT_SELECTOR)) return false;
    if (el.isContentEditable) return true;
    const tag = el.tagName;
    if (tag === "TEXTAREA" || tag === "SELECT") return true;
    if (tag === "INPUT") {
      return !NON_TEXT_INPUT_TYPES.has(String(el.type || "text").toLowerCase());
    }
    return false;
  } catch {
    return true;
  }
}

/**
 * Should the popup wait before appearing?
 *
 * @returns {boolean}
 */
export function isMomentBlocked() {
  return isOtherDialogOpen() || isTypingElsewhere();
}
